import React from 'react';
import { Hero } from '../components/Hero';
import { Timeline } from '../components/Timeline';
import { Categories } from '../components/Categories';
import { JuryCarousel } from '../components/JuryCarousel';
import { WhyEnter } from '../components/WhyEnter';
import { ReadyToEnter } from '../components/ReadyToEnter';

export const HomePage = () => {
  return (
    <>
      <Hero />
      <Timeline />
      <Categories />
      <JuryCarousel />
      <WhyEnter />
      <ReadyToEnter />
    </>
  );
};